import script from "./SidebarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&setup=true&lang=js"

import "./SidebarComponent.vue?vue&type=style&index=0&id=065c04ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065c04ec"]])

export default __exports__